var AVAILABLE_SPACE_RESERVE = 50;
var getOverflowParentDimensions = function (element, excludeClosestParent) {
    if (excludeClosestParent === void 0) { excludeClosestParent = false; }
    var parents = getOverflowParents(element).map(function (el) {
        var _a = el.getBoundingClientRect(), height = _a.height, width = _a.width, top = _a.top, left = _a.left;
        return {
            height: height,
            width: width,
            top: top,
            left: left
        };
    });
    parents.push({
        height: window.innerHeight,
        width: window.innerWidth,
        top: 0,
        left: 0
    });
    if (excludeClosestParent) {
        parents.shift();
    }
    return parents;
};
var getClosestParentDimensions = function (element) {
    var parents = getOverflowParents(element).map(function (el) {
        var _a = el.getBoundingClientRect(), height = _a.height, width = _a.width, top = _a.top, left = _a.left;
        return {
            height: height,
            width: width,
            top: top,
            left: left
        };
    });
    return parents.shift();
};
export var getOverflowParents = function (element) {
    var parents = [];
    var node = element;
    while ((node = node.parentElement)) {
        getComputedStyle(node).overflow !== 'visible' && parents.push(node);
    }
    return parents;
};
export var focusPreservingScroll = function (element) {
    var savedScrollPositions = saveParentScrollPositions(element);
    element.focus();
    // In Safari we need to restore the scrolling position
    // of the parent containers after focusing
    restoreParentScrollPositions(savedScrollPositions);
};
var saveParentScrollPositions = function (element) {
    return getOverflowParents(element).map(function (el) { return ({ scrollParent: el, prevScrollTop: el.scrollTop }); });
};
export var getAvailableSpace = function (trigger, dropdown) {
    var overflowParents = getOverflowParentDimensions(dropdown);
    var _a = trigger.getBoundingClientRect(), triggerBottom = _a.bottom, triggerLeft = _a.left, triggerRight = _a.right;
    return overflowParents.reduce(function (_a, overflowParent) {
        var above = _a.above, below = _a.below, left = _a.left, right = _a.right;
        var offsetTop = triggerBottom - overflowParent.top;
        var currentAbove = offsetTop - trigger.offsetHeight - AVAILABLE_SPACE_RESERVE;
        var currentBelow = overflowParent.height - offsetTop - AVAILABLE_SPACE_RESERVE;
        var currentLeft = triggerRight - overflowParent.left - AVAILABLE_SPACE_RESERVE;
        var currentRight = overflowParent.left + overflowParent.width - triggerLeft - AVAILABLE_SPACE_RESERVE;
        return {
            above: Math.min(above, currentAbove),
            below: Math.min(below, currentBelow),
            left: Math.min(left, currentLeft),
            right: Math.min(right, currentRight)
        };
    }, { above: Number.MAX_VALUE, below: Number.MAX_VALUE, left: Number.MAX_VALUE, right: Number.MAX_VALUE });
};
export var getInteriorAvailableSpace = function (trigger, dropdown) {
    var overflowParents = getOverflowParentDimensions(dropdown, true);
    var _a = trigger.getBoundingClientRect(), triggerBottom = _a.bottom, triggerTop = _a.top, triggerLeft = _a.left, triggerRight = _a.right;
    return overflowParents.reduce(function (_a, overflowParent) {
        var above = _a.above, below = _a.below, left = _a.left, right = _a.right;
        var currentAbove = triggerBottom - overflowParent.top - trigger.offsetHeight - AVAILABLE_SPACE_RESERVE;
        var currentBelow = overflowParent.height - triggerTop + overflowParent.top - AVAILABLE_SPACE_RESERVE;
        var currentLeft = triggerLeft - overflowParent.left - AVAILABLE_SPACE_RESERVE;
        var currentRight = overflowParent.left + overflowParent.width - triggerRight - AVAILABLE_SPACE_RESERVE;
        return {
            above: Math.min(above, currentAbove),
            below: Math.min(below, currentBelow),
            left: Math.min(left, currentLeft),
            right: Math.min(right, currentRight)
        };
    }, { above: Number.MAX_VALUE, below: Number.MAX_VALUE, left: Number.MAX_VALUE, right: Number.MAX_VALUE });
};
export var getDropdownPosition = function (trigger, dropdown, prefersDownDirection) {
    if (prefersDownDirection === void 0) { prefersDownDirection = false; }
    var availableSpace = getAvailableSpace(trigger, dropdown);
    var triggerWidth = trigger.getBoundingClientRect().width;
    var requiredWidth = dropdown.getBoundingClientRect().width;
    // dropdown should not be smaller than the trigger
    var idealWidth = Math.max(requiredWidth, triggerWidth);
    var dropLeft;
    var width = idealWidth;
    //1. Can it be positioned with ideal width to the right?
    if (idealWidth <= availableSpace.right) {
        dropLeft = false;
        //2. Can it be positioned with ideal width to the left?
    }
    else if (idealWidth <= availableSpace.left) {
        dropLeft = true;
        //3. Fit into biggest available space either on left or right
    }
    else {
        dropLeft = availableSpace.left > availableSpace.right;
        width = Math.max(availableSpace.left, availableSpace.right, triggerWidth);
    }
    var dropUp = availableSpace.below < dropdown.offsetHeight && availableSpace.above > availableSpace.below;
    if (prefersDownDirection && dropUp && availableSpace.above < dropdown.offsetHeight) {
        dropUp = false;
    }
    return {
        dropUp: dropUp,
        dropLeft: dropLeft,
        height: dropUp ? availableSpace.above + "px" : availableSpace.below + "px",
        width: width + "px"
    };
};
export var getInteriorDropdownPosition = function (trigger, dropdown) {
    var availableSpace = getInteriorAvailableSpace(trigger, dropdown);
    var _a = trigger.getBoundingClientRect(), triggerBottom = _a.bottom, triggerTop = _a.top, triggerWidth = _a.width;
    var _b = getClosestParentDimensions(trigger), parentDropdownTop = _b.top, parentDropdownHeight = _b.height;
    var dropLeft;
    var width = dropdown.getBoundingClientRect().width;
    var top = triggerTop - parentDropdownTop;
    if (width <= availableSpace.right) {
        dropLeft = false;
    }
    else if (width <= availableSpace.left) {
        dropLeft = true;
    }
    else {
        dropLeft = availableSpace.left > availableSpace.right;
        width = Math.max(availableSpace.left, availableSpace.right);
    }
    var left = dropLeft ? 0 - width : triggerWidth;
    var dropUp = availableSpace.below < dropdown.offsetHeight && availableSpace.above > availableSpace.below;
    var bottom = dropUp ? parentDropdownTop + parentDropdownHeight - triggerBottom : 0;
    return {
        dropUp: dropUp,
        dropLeft: dropLeft,
        height: dropUp ? availableSpace.above + "px" : availableSpace.below + "px",
        width: width + "px",
        top: top + "px",
        bottom: bottom + "px",
        left: left + "px"
    };
};
// `focus` method causes scrolling in Safari
// to prevent this we need to restore the previous scroll position
// of all the parent containers with overflow !== visible
// see more details on https://issues.amazon.com/issues/AWSUI-7290
// https://github.com/calvellido/focus-options-polyfill/blob/master/index.js
var restoreParentScrollPositions = function (savedScrollPositions) {
    // Hijacking the event loop order, since the focus() will internally
    // trigger scrolling that goes to the event loop
    window.setTimeout(function () {
        savedScrollPositions.forEach(function (_a) {
            var scrollParent = _a.scrollParent, prevScrollTop = _a.prevScrollTop;
            if (scrollParent.scrollTop !== prevScrollTop) {
                scrollParent.scrollTop = prevScrollTop;
            }
        });
    }, 0);
};
